import axios from "axios";
import { MKS_BACKEND_URL } from "src/utils/env";
import { GlobalUtils } from "src/utils/globalUtils";

/**
 * Fetches an authenticated image (/images/**) and returns an object URL usable as <img src>.
 * Caller should revoke the returned URL when no longer needed.
 */
export async function fetchAuthedImageObjectUrl(fileName: string): Promise<string> {
  const token = GlobalUtils.getToken();
  if (!token) throw new Error("Missing auth token");

  // Backend supports nested paths like: /images/profiles/<file>
  // Do NOT encode the whole string (it would turn '/' into '%2F').
  // Instead, encode each segment and re-join with '/'.
  const raw = String(fileName || "").replace(/^\//, "");
  const safePath = raw
    .split("/")
    .filter(Boolean)
    .map((seg) => encodeURIComponent(seg))
    .join("/");

  const url = `${MKS_BACKEND_URL}/images/${safePath}`;
  const res = await axios.get(url, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return URL.createObjectURL(res.data);
}
